/**
 * Use this factory to make common utility methods available $scope of jv.Cand.Details Controller
 */
angular.module('jv.candidate.details.util.factory',[])
.factory('jvCandidateDetailsConfigFAC', [function(){
    var serializeArray = function(arr, name, result) {
        result = result || [];
        if (arr.length === 0) {
            result.push({
                name: name,
                value: ''
            });
        } else {
            angular.forEach(arr, function(value) {
                result.push({
                    name: name,
                    value: value
                });
            });
        }
        return result;
    };

    return function(){
        return {
            //The method is used in scheduler to load interviewer's icon
            icon: function(obj) {
                var iconUrl;
                if (obj) {
                    iconUrl = obj.ProfilePictureUrl ? obj.ProfilePictureUrl : '/__assets__/images/icon-profilePic.png';
                } else {
                    iconUrl = '/__assets__/images/icon-profilePic.png';
                }
                return iconUrl;
            },
            /**
             * Converts a delimited string into an array like parameter string which can be used with the url for a GET request.
             * @param str
             * @param delim
             * @returns {String}
             */
            strToArrayParam: function(str, paramName, delim) {
                var toArr, data = '';
                if (!delim) {
                    delim = ',';
                }
                if (str) {
                    toArr = str.split(delim);
                    if (!$.isEmptyObject(toArr)) {
                        data = data + '&' + paramName + '=' + toArr.join('&' + paramName + '=');
                    }
                }
                return data;
            },
            decodeURIComponent: function(text) {
                if (text) {
                    return decodeURIComponent(text);
                }
            },
            encodeURIComponent: function(text) {
                if (text) {
                    return encodeURIComponent(text);
                }
            },
            /**
             * Removes the specified property from all the objects in the array.
             * Honestly this is the quickest solution to the pagination problem.
             */
            removeProperty: function(arr, property) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].hasOwnProperty(property)) {
                        delete arr[i][property];
                    }
                }
                return arr;
            },
            getStringInJson: function(jString) {
                if (typeof jString === 'string') {
                    return JSON.parse(jString);
                }
                return jString;
            },
            /**
             * Removes any duplicate objects from the array. The uniqProp is used as the unique property of the object to distunguish between \
             * duplicates(like a primary key).
             *
             * Underscore's uniq did not work for some weird reason and hence using this by leveraging the 'id' property which is unique.
             */
            removeDupes: function(arr, uniqProp) {
                var uniqueArr = [],
                    duplicates = {};
                $.each(arr, function(index, obj) {
                    if (!duplicates[obj[uniqProp]]) {
                        duplicates[obj[uniqProp]] = true;
                        uniqueArr.push(obj);
                    }
                });
                return uniqueArr;
            },

            processDate: function(dateStr) {
                var d = null;
                if (dateStr) {
                    d = new Date(dateStr);
                }
                return d;
            },
            serializeObject: function(obj) {
                var result = [];
                angular.forEach(obj, function(value, key) {
                    if (angular.isArray(value)) {
                        serializeArray(value, key, result);
                    } else if(angular.isObject(value)) {
                        result.push({
                            name: key,
                            value: JSON.stringify(value)
                        });
                    } else {
                        result.push({
                            name: key,
                            value: value
                        });
                    }
                });
                return result;
            },
            serializeArray: serializeArray,
            cleanString: function(str) {
                if (str) {
                    return str.replace(new RegExp('[\n]+', 'g'), '<br/>');
                }
            },
            splitString: function(str) {
                if (str) {
                    return str.split('\n');
                }
            },
            isCurrent: function(workflowIndicator, index) {
                switch (index) {
                    case 3:
                        if (angular.isDefined(workflowIndicator.Step4))  {
                            return true;
                        }
                        break;
                    case 2:
                        if (angular.isDefined(workflowIndicator.Step3))  {
                            return true;
                        }
                        break;
                    case 1:
                        if (angular.isDefined(workflowIndicator.Step2))  {
                            return true;
                        }
                        break;
                    case 0:
                        if (angular.isDefined(workflowIndicator.Step1))  {
                            return true;
                        }
                        break;
                    default:
                        break;
                }
                return false;
            },
            //Function to check if any of the workflow indicators should be empty. Will be making this logic smarter
            // and moving to directive if more than 2 instances are required.
            isEmpty: function(workflowIndicator, index) {
                switch (index) {
                    case 0:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3) && angular.isUndefined(workflowIndicator.Step2) && angular.isUndefined(workflowIndicator.Step1))  {
                            return true;
                        }
                        break;
                    case 1:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3) && angular.isUndefined(workflowIndicator.Step2)) {
                            return true;
                        }
                        break;
                    case 2:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3)) {
                            return true;
                        }
                        break;
                    case 3:
                        if (angular.isUndefined(workflowIndicator.Step4)) {
                            return true;
                        }
                        break;
                    default:
                        break;
                }
                return false;
            },
            massageContactInfoDetails: function(candidateDetails) {
                var result = {};
                var _ = require('lodash');
                require('lodash');
                angular.forEach(candidateDetails, function(value) {
                    if (!_.isEmpty(value.value)) {
                        switch (value.fieldId) {
                            //Email
                            case -3:
                                result.email = value.value;
                                break;
                            //Phone Numbers. Need to move to a constant.
                            case -62:
                            case -8:
                            case -9:
                                result.phone = value.value;
                                break;
                            //City
                            case -5:
                                result.city = value.value;
                                break;
                            //State
                            case -36:
                                result.state = value.value;
                                break;
                            //Country
                            case -7:
                                result.country = value.value;
                                break;
                            default:
                                break;
                        }
                    }
                });
                return result;
            },
            isRejected: function(workflowIndicator, index) {
                var indexFrom1 = index+1;
                var name = 'Step' + indexFrom1;
                if (workflowIndicator && workflowIndicator[name]) {
                    if (workflowIndicator[name].rejected) {
                        return true;
                    }
                }
                return false;
            },
            truncateFirstNameLastName: function(appDetails) {
                // ensure max number of characters are displayed
                // and we don't truncate unnecessarily
                var maxChars = 40;
                if (!appDetails) {
                    return;
                }
                var firstName = appDetails.application.candidate.firstName;
                var lastName = appDetails.application.candidate.lastName;
                var maxFirstNameChars = Math.max(maxChars / 2, (maxChars - Math.min(maxChars, lastName.length)));
                var maxLastNameChars = Math.max(maxChars / 2, (maxChars - Math.min(maxChars, firstName.length)));

                if (firstName.length > maxFirstNameChars) {
                    firstName = firstName.substr(0, maxFirstNameChars) + '...';
                }

                if (lastName.length > maxLastNameChars) {
                    lastName = lastName.substr(0, maxLastNameChars) + '...';
                }

                return firstName + ' ' + lastName;
            },
            customEmailTemplateSelectConfig: {
                ajax: {
                    type: 'GET',
                    data: function (term, page) {
                        return {
                            page: page - 1,
                            keywords: term
                        };
                    },
                    results: function(data, page){
                        var pageSize = 10;
                        var more = (page * pageSize) < data.count;
                        return {
                            results: data.userEmailTemplates,
                            more: more
                        };
                    }
                }
            }
        };
    };
}]);